/**
 * Canonical org id for billing / subscription APIs.
 * Prefer Auth0 org id fields over Mongo/internal ids, with a stable order so
 * payment-method, seat-impact, and confirm paths never diverge.
 */
export function getBillingOrgAuthId(
  organization?: {
    authId?: string;
    auth0OrgId?: string;
    id?: string;
  } | null,
): string | undefined {
  return organization?.authId || organization?.auth0OrgId || organization?.id;
}
